import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Image } from "react-bootstrap";
import logoEasyGouv from "../../assets/images/logoEasyGouvNoir.png";
import { BsStopwatch } from "react-icons/bs";
import { MdAutoGraph } from "react-icons/md";
import { GiEarthAfricaEurope, GiTrail, GiTreeDoor } from "react-icons/gi";
import { BsPersonFill } from "react-icons/bs";
import { Link } from "react-router-dom";

import fr from "../../assets/images/flag/fr.svg";
import en from "../../assets/images/flag/en.svg";
//import es from "../../assets/images/flag/es.svg";
//import al from "../../assets/images/flag/al.svg";

const ComponentFooter = (props) => {
  const { t, i18n } = useTranslation();

  const { menuActif } = props;
  const [lang, setLang] = useState(i18n.language);

  const changeLanguageHandler = (lang) => {
    setLang(lang);
    i18n.changeLanguage(lang);
  };

  return (
    <footer>
      <div className="containerFooterButtons d-lg-none d-xl-none d-xxl-none">
        <Link
          className={menuActif === "home" ? "footerButtons is-active" : "footerButtons"}
          to="/home"
        >
          <BsStopwatch size="3em" /> <div> {t("menu.menuGeneralFooter1")}</div>
        </Link>

        <Link
          className={menuActif === "ingovernance" ? "footerButtons is-active" : "footerButtons"}
          to="/ingovernance"
        >
          <MdAutoGraph size="3em" />
          <div> {t("menu.menuGeneralFooter2")}</div>
        </Link>

        <Link
          className={menuActif === "insocial" ? "footerButtons is-active" : "footerButtons"}
          to="/insocial"
        >
          <BsPersonFill size="3em" />
          <div> {t("menu.menuGeneralFooter3")}</div>
        </Link>

        <Link
          className={menuActif === "inoperation" ? "footerButtons is-active" : "footerButtons"}
          to="/inoperation"
        >
          <GiEarthAfricaEurope size="3em" />
          <div> {t("menu.menuGeneralFooter4")}</div>
        </Link>

        <Link
          className={menuActif === "inviews" ? "footerButtons is-active" : "footerButtons"}
          to="/inviews"
        >
          <GiTrail size="3em" />
          <div> {t("menu.menuGeneralFooter5")}</div>
        </Link>
        <Link
          className={menuActif === "espaces" ? "footerButtons is-active" : "footerButtons"}
          to="/espaces"
        >
          <GiTreeDoor size="3em" />
          <div> {t("menu.menuGeneralFooter6")}</div>
        </Link>
      </div>
      <div className="easygouv">
        <Image src={logoEasyGouv} height="20px" />
        <span className="d-flex align-items-center">
          <span> Version {process.env.REACT_APP_VERSION}</span>

          {lang !== "fr" && (
            <Image
              src={fr}
              onClick={() => changeLanguageHandler("fr")}
              height="20px"
              className="ms-2"
            />
          )}
          {lang !== "en" && (
            <Image
              src={en}
              onClick={() => changeLanguageHandler("en")}
              height="20px"
              className="ms-2"
            />
          )}
          {/* {lang !== "es" && (
            <Image
              src={es}
              onClick={() => changeLanguageHandler("es")}
              height="20px"
              className="ms-2"
            />
          )}
          {lang !== "al" && (
            <Image
              src={al}
              onClick={() => changeLanguageHandler("al")}
              height="20px"
              className="ms-2"
            />
          )} */}
        </span>
      </div>
    </footer>
  );
};

export default ComponentFooter;
